export default function Projects() {
    return (
        <div className="Projects" id="Projects" data-aos="fade-up" data-aos-duration="2000">
            <h3 className="text-center">👨‍💻 My Projects</h3>
            <ul>
                <li>
                    Full Stack Web App
                    <ul>
                        <li ><a href="https://github.com/Nimitha-jagadeesha/Epsilon-21.0" className="App-link">Epsilon</a>: A website done for conducting online treasure hunt event of a college fest (Django, Postgress SQL, HTML, CSS, Bootstrap, JS)</li>
                        <li>Impetus 21.0: A website done for college fest. (MongoDB, nodejs, HTML, CSS, JavaScript)
                            <ul>
                                <li>Github Link: <a href="https://github.com/Nimitha-jagadeesha/Impetus" className="App-link">https://github.com/Nimitha-jagadeesha/Impetus</a></li>
                                <li>Website Link: <a href="https://impetus-flax.vercel.app/">Impetus 21.0</a></li>
                            </ul>
                           </li>
                        <li>Agriculturify: A website to reduce food supply chain.
                            <ul>
                                <li><a href="https://github.com/Nimitha-jagadeesha/Agricutureify" className="App-link">Frontend </a>(React, HTML, CSS, Javascript)</li>
                                <li><a href="https://github.com/Nimitha-jagadeesha/AGRO-Backend-API" className="App-link"> Backend</a> (nodejs, express, MongDB)</li>
                            </ul>
                        </li>
                    </ul>
                </li>
                <li> Mobile Application Development
                    <ul>
                        <li>
                            <a href="https://github.com/Nimitha-jagadeesha/Covid-care" className="App-link"> Covid Care </a>(Java, XML, Firebase)
                        </li>
                    </ul>
                </li>
                 <li> GitHub Stats:
                    <p align="center">
                        <a href="https://github.com/Nimitha-jagadeesha">
                          <img alt="hackerrank" height="170em" src="https://github-readme-stats-eight-theta.vercel.app/api?username=Nimitha-jagadeesha&show_icons=true&theme=algolia&include_all_commits=true&count_private=true"/>
                          <img alt="hackerrank" height="170em" src="https://github-readme-stats-eight-theta.vercel.app/api/top-langs/?username=Nimitha-jagadeesha&layout=compact&langs_count=8&theme=algolia"/>
                        </a>
                    </p>
               </li>
            </ul>
        </div>
    )
}
